module.exports = __webpack_public_path__ + "static/nn2-77d80401e337b6d773d890d44ea72fa7.png";